module.exports = __webpack_public_path__ + "48a1b2d005ac47c289ef9e98b0df6609.png";